import React from 'react';
import useUser from '../hooks/useUser';
import ServerParentmasters from '../masters/server/Parentmasters';
import ClientParentmasters from '../masters/client/Parentmasters';

const Parentmasters = () => {
    const { userRole } = useUser();
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';
    if (roleLower === 'client') {
        return <ClientParentmasters />;
    }
    return <ServerParentmasters />;
};
export default Parentmasters;
